import request from 'apps/new-web/lib/request';

export function scheduleEvent(workoutId, date) {
  return request.post('/calendar/create_event')
    .send({
      workoutId,
      scheduleDate: date

    })
    .end()
    .then((res) => {
      return (res);
    })
    .catch((e) => {
      return (e);
    });
}
